'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = EventBrowser;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _caligramReact = require('caligram-react');

var _containers = require('../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventBrowser(_ref) {
  var mapView = _ref.mapView,
      push = _ref.push,
      title = _ref.title;

  var dateFormat = function dateFormat(_ref2) {
    var start_date = _ref2.start_date;
    return (0, _moment2.default)(start_date).format('HH[h]mm');
  };

  return _react2.default.createElement(
    'main',
    { className: 'EventBrowser ' + (mapView ? 'map' : 'list') },
    _config2.default.app.show.mapToggle && _react2.default.createElement(
      'div',
      { className: 'viewToggle' },
      _react2.default.createElement(_containers.ViewToggleContainer, { push: push })
    ),
    mapView ? _react2.default.createElement(_containers.EventsMapContainer, null) : /* The extra div is a necessity of React 15. This should be removed (and styles updated) when we migrate to 16 */
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_containers.SearchBarContainer, null),
      _react2.default.createElement(_caligramReact.Button, { title: 'Filtrer par date, lieu, type d\u2019activit\xE9...', className: 'filtersLink', href: '#filters', width: 'full' }),
      _react2.default.createElement(
        'div',
        { className: 'events' },
        _react2.default.createElement(
          _containers.EventListContainer,
          { title: title },
          function (props) {
            return _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'grid', columns: 2, dateFormat: dateFormat }, props));
          }
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'filters' },
        _react2.default.createElement(_containers.FiltersContainer, null)
      )
    )
  );
}

EventBrowser.propTypes = {
  mapView: _react.PropTypes.bool,
  title: _react.PropTypes.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EventBrowser.js
// module id = 1074
// module chunks = 0